import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../../assets/images/shoppers_stop_logo.png";
import dashboardIcon_dark from "../../../assets/icons/dashboardIcon_dark.png";
import dashboardIcon_light from "../../../assets/icons/dashboardIcon_light.png";
import createIcon_dark from "../../../assets/icons/createIcon_dark.png";
import createIcon_light from "../../../assets/icons/createIcon_light.png";
import taskIcon_dark from "../../../assets/icons/taskIcon_dark.png";
import taskIcon_light from "../../../assets/icons/taskIcon_light.png";
import exhibitionIcon_dark from "../../../assets/icons/exhibitionIcon_dark.png";
import exhibitionIcon_light from "../../../assets/icons/exhibitionIcon_light.png";
import profileIcon_dark from "../../../assets/icons/profileIcon_dark.png";
import profileIcon_light from "../../../assets/icons/profileIcon_light.png";
import subscriptionModelIcon_dark from "../../../assets/icons/subscriptionModelIcon_dark.png";
import subscriptionModelIcon_light from "../../../assets/icons/subscriptionModelIcon_light.png";
import socialMediaIcon_dark from "../../../assets/icons/socialMediaIcon_dark.png";
import socialMediaIcon_light from "../../../assets/icons/socialMediaIcon_light.png";
import reportIcon_dark from "../../../assets/icons/reportIcon_dark.png";
import reportIcon_light from "../../../assets/icons/reportIcon_light.png";
import helpIcon_dark from "../../../assets/icons/helpIcon_dark.png";
import helpIcon_light from "../../../assets/icons/helpIcon_light.png";
import serverProcessingIcon_dark from "../../../assets/icons/serverProcessingIcon_dark.png";
import serverProcessingIcon_light from "../../../assets/icons/serverProcessingIcon_light.png";

const Sidebar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="flex flex-col h-full items-center bg-[#F8F8F8] ">
      <img src={logo} alt="logo" className="w-[50%] mt-7 mb-7" />
      <div className="flex flex-col justify-between w-[80%]">
        <Link to="/admin">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/admin") ? "active" : ""
            }`}
          >
            {isActive("/admin") ? (
              <img
                src={dashboardIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="dashboard icon"
              />
            ) : (
              <img
                src={dashboardIcon_dark}
                className="mr-3 text-white w-[30px]"
                alt="dashboard icon"
              />
            )}
            Dashboard
          </div>
        </Link>
        <Link to="/admin/create/select">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/admin/create") ? "active" : ""
            }`}
          >
            {isActive("/admin/create") ? (
              <img
                src={createIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="create icon"
              />
            ) : (
              <img
                src={createIcon_dark}
                alt="create icon"
                className="mr-3 text-white w-[30px]"
              />
            )}
            Create
          </div>
        </Link>
        <Link to="/admin/tasks">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/admin/tasks") ||
              isActive("/admin/tasks/create-task") ||
              isActive("/admin/tasks/customer-history")
                ? "active"
                : ""
            }`}
          >
            {isActive("/admin/tasks") ||
            isActive("/admin/tasks/create-task") ||
            isActive("/admin/tasks/customer-history") ? (
              <img
                src={taskIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="Active Task Icon"
              />
            ) : (
              <img
                src={taskIcon_dark}
                className="mr-3 text-white w-[30px]"
                alt="Inactive Task Icon"
              />
            )}
            Tasks
          </div>
        </Link>
        <Link to="/admin/exhibition">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/admin/exhibition") ? "active" : ""
            }`}
          >
            {isActive("/admin/exhibition") ? (
              <img
                src={exhibitionIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="exhibition icon"
              />
            ) : (
              <img
                src={exhibitionIcon_dark}
                className="mr-3 text-white w-[30px]"
                alt="exhibition icon"
              />
            )}
            Exhibition
          </div>
        </Link>
        <Link to="/admin/profile">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/admin/profile") ? "active" : ""
            }`}
          >
            {isActive("/admin/profile") ? (
              <img
                src={profileIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="profile icon"
              />
            ) : (
              <img
                src={profileIcon_dark}
                className="mr-3 text-white w-[30px]"
                alt="profile icon"
              />
            )}
            Profile
          </div>
        </Link>
        <Link to="/admin/subscriptions">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/admin/subscriptions") ? "active" : ""
            }`}
          >
            {isActive("/admin/subscriptions") ? (
              <img
                src={subscriptionModelIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="subscription model icon"
              />
            ) : (
              <img
                src={subscriptionModelIcon_dark}
                className="mr-3 text-white w-[30px]"
                alt="subscription model icon"
              />
            )}
            Subscription Model
          </div>
        </Link>
        <Link to="/admin/social-media-integration">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/admin/social-media-integration") ? "active" : ""
            }`}
          >
            {isActive("/admin/social-media-integration") ? (
              <img
                src={socialMediaIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="social media icon"
              />
            ) : (
              <img
                src={socialMediaIcon_dark}
                className="mr-3 text-white w-[30px]"
                alt="social media icon"
              />
            )}
            Social Media Integration
          </div>
        </Link>
        <Link to="/admin/report">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer ${
              isActive("/admin/report") ? "active" : ""
            } my-4`}
          >
            {isActive("/admin/report") ? (
              <img
                src={reportIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="report"
              />
            ) : (
              <img
                src={reportIcon_dark}
                alt="report"
                className="mr-3 text-white w-[30px]"
              />
            )}
            Report
          </div>
        </Link>
        <Link to="/admin/support">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer ${
              isActive("/admin/support") ? "active" : ""
            } mb-4`}
          >
            {isActive("/admin/support") ? (
              <img
                src={helpIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="help and support"
              />
            ) : (
              <img
                src={helpIcon_dark}
                alt="help and support"
                className="mr-3 text-white w-[30px]"
              />
            )}
            Help & Support
          </div>
        </Link>
        <Link to="/admin/server-processing">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer ${
              isActive("/admin/server-processing") ? "active" : ""
            } mb-4`}
          >
            {isActive("/admin/server-processing") ? (
              <img
                src={serverProcessingIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="server-processing"
              />
            ) : (
              <img
                src={serverProcessingIcon_dark}
                alt="server-processing"
                className="mr-3 text-white w-[30px]"
              />
            )}
            Server Processing Time
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Sidebar;
